if (!customElements.get('shape-size-guide')) {
  customElements.define('shape-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.trigger = this.querySelector('[data-guide-open]');
      this.dialog = this.querySelector('dialog');
      this.tabs = [...this.querySelectorAll('[data-guide-tab]')];
      this.panels = [...this.querySelectorAll('[data-guide-panel]')];
      if (!this.trigger || !this.dialog || !this.tabs.length) return;

      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.productRoot = this.closest('[data-section-type="product"]');
      this.selectProductShape();
      this.trigger.hidden = false;
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-guide-open]')) {
          if (!this.dialog.open) {
            this.selectProductShape();
            this.dialog.showModal();
          }
          return;
        }
        if (event.target.closest('[data-guide-close]')) {
          this.dialog.close();
          return;
        }
        const tab = event.target.closest('[data-guide-tab]');
        if (tab) this.selectTab(tab);
        if (event.target === this.dialog) {
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right ||
              event.clientY < bounds.top || event.clientY > bounds.bottom) {
            this.dialog.close();
          }
        }
      }, options);

      this.addEventListener('keydown', (event) => {
        const tab = event.target.closest('[data-guide-tab]');
        if (!tab) return;
        let index = this.tabs.indexOf(tab);
        if (event.key === 'ArrowRight') index = (index + 1) % this.tabs.length;
        else if (event.key === 'ArrowLeft') index = (index - 1 + this.tabs.length) % this.tabs.length;
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = this.tabs.length - 1;
        else return;
        event.preventDefault();
        event.stopPropagation();
        this.selectTab(this.tabs[index]);
        this.tabs[index].focus();
      }, options);

      this.dialog.addEventListener('close', () => {
        if (this.trigger.isConnected) this.trigger.focus({ preventScroll: true });
      }, options);

      this.productRoot?.addEventListener('change', (event) => {
        const position = this.dataset.sizeOptionPosition;
        if (position && event.target.name === `option${position}`) this.selectProductShape();
      }, options);
    }

    static shapeFromSize(value) {
      const size = String(value || '').replace(/["'\u2032\u2033\u201c\u201d]/g, '').replace(/[x\u00d7]/gi, ' x ');
      const number = '(\\d+(?:[.,]\\d+)?)';
      const unit = '(?:\\s*(?:inches|inch|in|cm))?';
      const dimension = (axis, word) => {
        const suffix = size.match(new RegExp(`${number}${unit}\\s*(?:${word}|${axis})\\b`, 'i'));
        const prefix = size.match(new RegExp(`\\b(?:${word}|${axis})\\s*[:=]?\\s*${number}`, 'i'));
        return Number((suffix?.[1] || prefix?.[1] || '').replace(',', '.'));
      };
      let width = dimension('w', 'width');
      let height = dimension('h', 'height');
      if (!width || !height) {
        const pair = size.match(new RegExp(`${number}\\s*x\\s*${number}`, 'i'));
        // A partially labelled size is ambiguous; do not guess which axis is missing.
        if (!pair || width || height) return null;
        width = Number(pair[1].replace(',', '.'));
        height = Number(pair[2].replace(',', '.'));
      }
      if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) return null;
      const ratio = width / height;
      if (ratio >= 0.95 && ratio <= 1.05) return 'square';
      if (ratio >= 1.8) return 'panoramic';
      if (ratio <= 1 / 1.8) return 'tall_vertical';
      return ratio > 1 ? 'horizontal' : 'vertical';
    }

    selectProductShape() {
      const position = this.dataset.sizeOptionPosition;
      const selectedSize = position && this.productRoot?.querySelector(
        `input[name="option${position}"]:checked, select[name="option${position}"]`
      );
      const shape = this.dataset.productShape || this.constructor.shapeFromSize(
        selectedSize?.value || this.dataset.initialSize
      ) || 'vertical';
      const tab = this.tabs.find((item) => item.dataset.guideTab === shape);
      if (tab) this.selectTab(tab);
    }

    selectTab(selected) {
      this.tabs.forEach((tab) => {
        const active = tab === selected;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.guidePanel !== selected.dataset.guideTab;
      });
      this.querySelector('.shape-size-guide__panels').scrollTop = 0;
    }

    disconnectedCallback() {
      this.events?.abort();
      this.events = null;
      if (this.dialog?.open) this.dialog.close();
    }
  });
}
